export const CaretUpIcon = (_p: React.ComponentProps<"svg">) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Caret Up"
  >
    <path
      d="M3.37603 8.625C3.1241 8.625 2.89556 8.44225 2.79803 8.16109C2.70029 7.87994 2.755 7.55895 2.93267 7.3434L6.05744 3.59465C6.30156 3.30178 6.69801 3.30178 6.94213 3.59465L10.0669 7.3434C10.2465 7.55895 10.2993 7.87994 10.2016 8.16109C10.104 8.44225 9.87742 8.625 9.62549 8.625H3.37603Z"
      fill="currentColor"
    />
  </svg>
);
